export const T = {
  en_GB: {
    loading: "Loading...",
    title: "Authorized Applications",
    description:
      "Applications you've authorized to access your Quantfolio Platform account via OAuth",
    application: "Application",
    scopes: "Permissions",
    authorizedOn: "Authorized",
    actions: "Actions",
    revoke: "Revoke",
    noApps: "No authorized applications",
    noAppsDescription:
      "When you connect applications like Claude Desktop via OAuth, they will appear here.",
    revokeTitle: "Revoke Access",
    revokeDescription:
      "Are you sure you want to revoke access for this application? It will need to be re-authorized to access your account again.",
    cancel: "Cancel",
    revokeConfirm: "Revoke Access",
    fullAccess: "Full access",
  },
  nb_NO: {
    loading: "Laster...",
    title: "Autoriserte applikasjoner",
    description:
      "Applikasjoner du har autorisert til å få tilgang til Quantfolio Platform-kontoen din via OAuth",
    application: "Applikasjon",
    scopes: "Tillatelser",
    authorizedOn: "Autorisert",
    actions: "Handlinger",
    revoke: "Tilbakekall",
    noApps: "Ingen autoriserte applikasjoner",
    noAppsDescription:
      "Når du kobler til applikasjoner som Claude Desktop via OAuth, vil de vises her.",
    revokeTitle: "Tilbakekall tilgang",
    revokeDescription:
      "Er du sikker på at du vil tilbakekalle tilgang for denne applikasjonen? Den må autoriseres på nytt for å få tilgang til kontoen din igjen.",
    cancel: "Avbryt",
    revokeConfirm: "Tilbakekall tilgang",
    fullAccess: "Full tilgang",
  },
} as const;
